import '../i18n/i18n'
import MarketingPage from '../components/templates/MarketingPage'
import { getAllStrapiPages, getHeaderQuery, getStrapiPageQuery } from '../lib/strapi/queries'
import { GetStaticProps } from 'next'
import { Header, StrapiPage } from '../lib/strapi/responseTypes'
import StrapiZoneMapper from '../components/StrapiDynamicZones/StrapiZoneMapper'
import config, { IS_PRODUCTION } from '../config'
import { useRouter } from 'next/router';

type StrapiPageData = { pageData: StrapiPage | null, headerData: Header | null }

type DynamicPageProps = StrapiPageData

export default function DynamicPage({ pageData, headerData }: DynamicPageProps) {

  const { asPath } = useRouter();

  if (pageData && headerData) {
    return (
      <MarketingPage
        description={pageData.attributes.Description}
        pageTitle={pageData.attributes.PageTitle}
        menuItems={headerData.data.attributes.menuItems}
        currentPage={asPath}
      >
        {pageData.attributes.Body.map((zone) => (
          <StrapiZoneMapper
            key={zone.__typename}
            dynamicZoneName={zone.__typename}
            {...zone}
          />
        ))}
      </MarketingPage>
    )
  }

  return <>404</>
}

export const getStaticProps: GetStaticProps<
  StrapiPageData,
  { dynamicPage: string }
> = async (context) => {
  const pageSlug = context?.params?.dynamicPage

  // fetch the corresponding strapi page for the requested slug
  const res = await getStrapiPageQuery({
    slug: pageSlug!,
    showPreview: !IS_PRODUCTION,
  })

  const headerData = await getHeaderQuery({
    showPreview: !IS_PRODUCTION,
  })

  const [returnedPage] = res.pages.data

  // if a page exists return it's data, otherwise return null and render a 404
  if (config.strapi.enabledContentModels.includes('Pages') && returnedPage) {
    return { props: { pageData: returnedPage, headerData: headerData.header,  key: pageSlug } }
  }

  return { props: { pageData: null, headerData: null, key: pageSlug  } }
}

export const getStaticPaths = async () => {
  // fetch all the data from the strapi "page" model and tell next about them
  const allPages = await getAllStrapiPages(!IS_PRODUCTION)
  return {
    paths: allPages?.pages?.data.map((page) => `/${page.attributes.Slug}`) || [],
    fallback: false,
  }
}
